<template>
  <Card>
    <AjaxForm :route="'admin/AuctionRequest/Edit/'+req._id" v-if="req" :callback="editCallback">
    <div class="row" >
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>شماره درخواست : {{req.number}}</label>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        درخواست دهنده :
        {{req.user_id.title}}
        ({{req.user_id.phone}})
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>تاریخ ثبت : </label>
        {{req.createdAt}}
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>محصول : </label>
        {{req.product_title}}
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>ویژگی ها :</label>
        <span >{{req.attribute_string}}</span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>برند :
        </label> <span> {{(req.brand_title)}}</span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>کشور :
        </label> <span> {{(req.country_title)}}</span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>تاریخ اعتبار:
        {{req.credit_date}}
        </label>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>تعداد کالا : </label><span>{{req.quantity}}</span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>قیمت آغازین : </label><span><Money :number="req.start_price"></Money></span>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>قیمت نهایی : </label><money :number="req.final_price"></money>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>گام قیمت : </label><money :number="req.step_price"></money>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <label>کالا دست دوم : </label><span>{{(req.secondhand?'می باشد':'نمی باشد')}}</span>
      </div>
      <div content="col-12 col-sm-6 col-md-3 mb-3">
        <label>توضیحات برای پیشنهاد دهندگان : </label>
        <div content="mt-1">{{(req.description?req.description:'--')}}</div>
      </div>
      <div class="col-12 mb-3">
        <div class="my-2">
          <label class="">تصاویر آپلود شده</label>&nbsp;
          <button @click="addNewPic" class="btn btn-info btn-sm" type="button" >افزودن تصویر جدید</button>
        </div>
        <div v-if="false && req.pics_names && req.pics_names.length" class="d-flex">
          <a :href="img_prefix+p" v-for="p in req.pics_names" :key="p" target="_blank" class="img-div">
            <i class="far fa-times"></i>
            <input type="hidden" name="pic_name[]" :value="p" readonly hidden>
            <img :src="img_prefix+p"/>
          </a>
        </div>
        <input v-for="d in del_pics" :key="d" type="hidden" name="del_pic[]" :value="d" readonly hidden>
        <div v-if="req.pics_names && req.pics_names.length" class="d-flex">
          <a :href="img_prefix+p" v-for="(p,index) in req.pics_names" :key="p" target="_blank" class="img-div">
            <i @click.prevent="deletePic(index)" class="far fa-trash-can del-btn"></i>
            <img :src="img_prefix+p"/>
          </a>
        </div>
        <div v-else>--</div>
        <div class="added_pics_div">
          <div v-for="(n,index) in new_pics" :key="n" class="added_pic">
            <i @click.prevent="deleteAddedPic(index)" class="far fa-trash-can del-new-pic" ></i>
            <DragDropFileUpload height="150" :compress="true" name="new_pic"></DragDropFileUpload>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-3 mb-3">
        <label>آخرین ویرایش کننده : </label>
        <div v-if="req.last_edit_user_id">
          <div>{{req.last_edit_user_id.fullname}}</div>
          <div>{{req.last_edit}}</div>
        </div>
        <div v-else>--</div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3" v-if="req.status === 'waiting' || req.status === 'confirmed'">
        <CustomInput :not-select-append-to-body="!!request_id" input_style="twoLine"
                     type="select" name="status"
                     :select-options="statuses"
                     v-model="select_status"
                     reduce_select="value"
                     placeholder="وضعیت را انتخاب کنید"
                     select-label="title"
                     label="انتخاب وضعیت"></CustomInput>
      </div>
      <div v-else>
        وضعیت درخواست :
        <span v-if="req.status === 'denied'">رد شده</span>
        <span v-if="req.status === 'finished'">تمام شده</span>
        <span v-if="req.status === 'canceled'">لغو شده</span>
      </div>
      <div class="col-12 col-sm-12 col-md-8 mb-3" v-if="req.status === 'waiting' || req.status === 'confirmed'">
        <CustomInput input_style="twoLine" type="textarea" name="deny_reason" placeholder="دلیل رد کردن..."
                     label="دلیل رد درخواست :"
                     v-model="req.deny_reason"
        ></CustomInput>
      </div>
      <div v-else-if="req.deny_reason">دلیل رد درخواست :
      {{req.deny_reason}}
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3"></div>
    </div>
      <div class="row" v-if="req.status === 'waiting' || req.status === 'confirmed'">
        <div class="col-10 col-sm-8 col-md-5 mx-auto">
          <button class="btn btn-info btn-block">ویرایش درخواست</button>
        </div>
      </div>
      <div class="h6 font-weight-bold">پیشنهادها</div>
      <LocalDataTable :functions="functions" :columns="columns" :ajax-link="ajaxLink"></LocalDataTable>
    </AjaxForm>
    <div class="alert alert-danger" v-if="error">
      {{error}}
    </div>
    <div ref="ttt" class="d-none">
      <AuctionOfferInfoModal :offer="offer"></AuctionOfferInfoModal>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";
import {date, findSelectItem, showSystemNoti, sleep} from "@/shared/helper";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";
import LocalDataTable from "@/components/LocalDataTable";
import AuctionOfferInfoModal from "@/components/AuctionOfferInfoModal";
import Swal from "sweetalert2";
import Money from "@/components/Money";
import DragDropFileUpload from "@/components/DragDropFileUpload";
let mounted = false;
export default {
name: "AuctionRequestEdit",
  props:['request_id'],
  components: {DragDropFileUpload, Money, AuctionOfferInfoModal, LocalDataTable, AjaxForm, CustomInput, Card},
  data()
  {
    return{
      offer : null,
      columns:[
        {title : 'شماره'},
        {title : 'خریدار'},
        {title : 'تاریخ'},
        {title : 'محصول'},
        {title : 'ویژگی'},
        {title : 'وضعیت'},
        {title : '<i class="far fa-cogs"></i>'},
      ],
      is_mounted : mounted,
      ajaxLink : '',
      functions : [{name : 'showAuctionOfferInfo',method: this.showAuctionOfferInfo}],
      img_prefix : process.env.VUE_APP_API_URL+process.env.VUE_APP_USER_STORAGE,
      id : this.$route.params.id,
      req : null,
      error : null,
      statuses : [
        {title :'درانتظار بررسی',value : 'waiting'},
        {title :'تایید شده',value : 'confirmed'},
        {title :'رد شده',value : 'denied'},
      ],
      select_status :null,
      new_pics : [],
      del_pics : [],
    }
  },
  mounted()
  {
    if (!this.request_id)
    {
      this.setPageLoading(false);
      this.setPageTitle('مشاهده درخواست مزائده');
      this.setShowHead(true);
    }

    this.is_mounted = mounted;
    mounted = true;
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    editCallback(data)
    {
      if (data.ok)
        return showSystemNoti('success',data.message,()=>{
          this.initPage();
        })
      else
        return showSystemNoti('danger',data.error);
    },
    async initPage()
    {
      this.new_pics = [];
      this.del_pics = [];
      this.error = null;
      this.req = null;
      this.setPageLoading(true);
      this.id = this.$route.params.id;
      if (!this.id && this.request_id)
      {
        this.id = this.request_id;
      }
      this.ajaxLink = 'admin/AuctionRequest/offerList/'+this.id;
      const result = await AppApi.getAuctionRequestInfoForEdit(this.id);
      if (result.ok)
      {
        this.req = result.req;
        this.req.createdAt = date(this.req.createdAt,true);
        this.req.credit_date = date(this.req.credit_date);
        this.req.last_edit = date(this.req.last_edit_date,true);
        this.select_status = findSelectItem(this.req.status,this.statuses,'value');
      }
      else
        this.error = result.error;
      this.setPageLoading(false);
    },
    async showAuctionOfferInfo(id)
    {
      this.setPageLoading(true);
      const result = await AppApi.getAuctionOfferInfo(id);
      if (result)
      {
        this.offer = result.offer;
        const self = this;
        const h = this.$refs.ttt;
        setTimeout(function (){
          Swal.fire({
            html: (h?h.innerHTML:''),
            width: '1000px',
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
          }).then((result)=>{
            if (result.isDismissed)
            {
              self.offer = null;
            }
          })
        },200)
      }
      else
        showSystemNoti('danger',result.error);
      this.setPageLoading(false);
    },
    deletePic(index)
    {
      this.del_pics.push(this.req.pics_names[index]);
      this.req.pics_names.splice(index,1);
    },
    addNewPic()
    {
      this.new_pics.push('');
    },
    deleteAddedPic(index)
    {
      this.new_pics.splice(index,1);
    }
  }
}
</script>

<style scoped>
.img-div
{
  margin-left: 5px;
  width: 100px;
  height: 100px;
  border: 1px solid silver;
  position: relative;
}
.img-div img
{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.img-div .del-btn {
  color: #f95d5d;
  font-size: 19px;
  position: absolute;
  top: 0;
  left: 0;
  background: white;
  border: 1px solid;
  padding: 5px;
  border-radius: 50%;
}
.added_pics_div {
  display: flex;
  grid-column-gap: 5px;
  flex-wrap: wrap;
  margin: 10px 0;
}
.added_pics_div .added_pic
{
  flex: 0 0 150px;
  position: relative;
}
.del-new-pic {
  font-size: 17px;
  color: red;
  position: absolute;
  left: 0;
  background: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 29px;
}
</style>